import "./game.scss";
import React, { useState, useEffect } from "react";
import { getUserScore, getRank, isUsernameSet } from "../../services/score";
import { Link, useNavigate } from "react-router-dom";
import Score from "../../components/score/score";
import Flipper from "../../components/coin-flipper/flipper";
import Message from "../../components/message/message";
import { useAuth } from "../../services/auth";
import { getNextFlipTime } from "../../services/score";
import { getGuestScore } from "../../services/guest-score";
import Loader from "../../components/loader/loader";
import { pageView } from "../../services/events";

const Home = () => {
    const [scoreDoc, setScoreDoc] = useState(null);
    const [heighScoreRank, setHighScoreRank] = useState(null);
    const [currentScoreRank, setCurrentScoreRank] = useState(null);
    const [nextFlipTime, setNextFlipTime] = useState(null);
    const [guestScore, setGuestScore] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { user, loading } = useAuth();

    useEffect(() => {
        pageView("game");
    }, []);

    useEffect(() => {
        if (loading) return;

        // Guest mode
        if (!user) {
            setScoreDoc(null);
            setGuestScore(getGuestScore());
            setIsLoading(false);
            return;
        }

        getUserScore(user).then((score) => {
            if (score.error) {
                setIsLoading(false);
                return;
            }

            const isUsernameExistsInDoc = isUsernameSet(score);
            if (!isUsernameExistsInDoc) {
                navigate("/login?step=username");
                return;
            }

            setScoreDoc(score);
            getRank(user, true, score).then((rank) =>
                setHighScoreRank(rank)
            );
            getRank(user, false, score).then((rank) =>
                setCurrentScoreRank(rank)
            );
            getNextFlipTime(user, score).then((time) =>
                setNextFlipTime(time)
            );
        });
    }, [loading, user]);

    const loadData = async () => {
        await getRank(user, true, scoreDoc).then((rank) =>
            setHighScoreRank(rank)
        );
        await getRank(user, false, scoreDoc).then((rank) =>
            setCurrentScoreRank(rank)
        );
        await getNextFlipTime(user, scoreDoc).then((time) =>
            setNextFlipTime(time)
        );
    };

    useEffect(() => {
        if (scoreDoc) {
            loadData().then(() => setIsLoading(false));
        }
    }, [scoreDoc]);

    if (isLoading) {
        return (
            <section className="game">
                <Loader />
            </section>
        );
    }

    // ── Guest mode ──
    if (!user) {
        return (
            <section className="game">
                <section className="section-score">
                    <Score scoreDoc={guestScore} rank={null} />
                    <Score isHighScore scoreDoc={guestScore} rank={null} />
                </section>

                <section className="section-flipper">
                    <Flipper
                        scoreDoc={null}
                        setScoreDoc={setScoreDoc}
                        guestScore={guestScore}
                        setGuestScore={setGuestScore}
                    />
                </section>

                <section className="section-guest-cta">
                    <p>
                        <Link to="/login">Sign in</Link> to save your streak to the
                        leaderboard
                    </p>
                </section>
            </section>
        );
    }

    // ── Logged-in mode ──
    return (
        <section className="game">
            <section className="section-score">
                <Score scoreDoc={scoreDoc} rank={currentScoreRank} />
                <Score
                    isHighScore
                    scoreDoc={scoreDoc}
                    rank={heighScoreRank}
                />
            </section>

            <section className="section-flipper">
                <Flipper
                    scoreDoc={scoreDoc}
                    setScoreDoc={setScoreDoc}
                    guestScore={null}
                    setGuestScore={setGuestScore}
                />
            </section>

            <section className="section-message">
                <Message
                    scoreDoc={scoreDoc}
                    nextFlipTime={nextFlipTime}
                />
            </section>
        </section>
    );
};

export default Home;
